import * as t from "io-ts";
import { nullable } from "./index";
export const createCargoDocumentTypes = ({ dateTime, }) => {
    const cargoDocumentBaseT = t.strict({
        id: t.string,
        name: t.string,
        fileType: t.string,
        documentType: t.string,
        time: dateTime,
        addedAt: dateTime,
        addedBy: t.union([
            t.strict({
                userType: t.literal("DRIVER"),
                driverId: t.string,
            }),
            t.strict({
                userType: t.literal("WEB_BOOKER"),
                webBookerId: t.string,
            }),
            t.strict({
                userType: t.literal("DISPATCHER"),
                dispatcherId: t.string,
            }),
            t.strict({
                userType: t.literal("PUBLIC_API"),
            }),
        ]),
    });
    const cargoDocumentT = t.intersection([
        cargoDocumentBaseT,
        t.strict({
            url: t.string,
            urlNew: t.string,
            urlPreview: nullable(t.string),
            urlPreviewNew: nullable(t.string),
        }),
    ]);
    const cargoDocumentsBaseT = t.array(cargoDocumentBaseT);
    const cargoDocumentsT = t.array(cargoDocumentT);
    return { cargoDocumentT, cargoDocumentsT, cargoDocumentsBaseT };
};
//# sourceMappingURL=cargo-document.js.map